<template>
  <div>
    <div>
      <div v-if="this.videoUrl">
        <Media
        :kind="'video'"
        :controls="true"
        :src="this.rowData.Videourl"
        :autoplay="true"
        style="width: -webkit-fill-available"
      >
      </Media>
      </div>
      <div v-else>
        <iframe
          :src="this.directUrl"
          height="500"
          width="1000"
          frameborder="0"
        ></iframe>
      </div>
    </div>
    
    <v-card class="py-8 px-14" color="transparent" flat>
      <h4>{{ this.rowData.Title }}</h4>
      <p class="primary--text my-3">{{ this.rowData.SubmittedBy }} | {{ this.rowData.Modality}}</p>
      <p>
       {{ this.rowData.Description }}
      </p>
    </v-card>
  </div>
</template>

<script>
import Media from "@dongido/vue-viaudio";
import { mapGetters } from "vuex";
export default {
  name: "PreviewVideoComponent",
  props: {
    selectedRowData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Media,
  },
  computed: {
    ...mapGetters([
      "GetSiteUser",
    ]),
   
  },
  mounted() {
   this.rowData = this.selectedRowData
   console.log("process.env.VUE_APP_API_URL",process.env.VUE_APP_API_URL);
   var url = this.rowData.Videourl;
   this.renderVideoByUrl(url);
  },
  data(){
return{
  rowData: {},
  submittedByName: "",
  videoUrl:"",
  directUrl:"",
  youtubeUrl:null
}
  },
  methods: {
    renderVideoByUrl(url){
      var isDirectUrl = url.includes(process.env.VUE_APP_API_URL);
      if(url.includes('youtube.com')){
        const videoId = url.match(/(?:\?|&)v=([^&#]+)/)[1];
        this.directUrl = `https://www.youtube.com/embed/${videoId}`;
        return this.directUrl;
      }
      else if(!isDirectUrl){
        this.directUrl = url
        return this.directUrl;
      }
      else{
        this.videoUrl = url;
        return this.videoUrl;
      }
      
    },
    handle() {
      console.log("Video paused!, playing in 2 sec...");

      setTimeout(() => {
        this.$refs.fish.play();
      }, 2000);
    },
  },
};
</script>
